import { SET_VOUCHERS } from "../types";

const initialState = {
  vouchers: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VOUCHERS:
      return {
        ...state,
        vouchers: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
